import './App.css';
import React from 'react';
import VideoOCR from './components/ocr';

export const App = () => {
  return(
    <div className='app'>
      <VideoOCR/>
    </div>
  )
}